<template>
  <v-main class="full-height full-width">
    <center>
      <v-progress-circular indeterminate class="verticle-center horizontaly-center" width="2"/>
    </center>
  </v-main>
</template>

<script>
  import authSession from "../../service/auth-session";

  export default {
    name: 'LoadingAuth',
    components: {
    },
    data: () => ({

    }),
    computed: {

    },
    mounted: function() {
      // Warms the `painel` chunk's cache during the post-login transition,
      // in parallel with the session check below — replaces the blanket
      // static prefetch removed from every page in vue.config.js, without
      // paying its cost on anonymous marketing pages.
      import(/* webpackChunkName: "painel" */ "@/components/pages/painel/Painel.vue")
      authSession.checkSession(true).then(authenticated => {
        if(authenticated) {
          if(localStorage.route) {
            const route = localStorage.route
            localStorage.removeItem('route')
            this.$router.push(route)
          } else {
            this.$router.push('/painel/links/shortened')
          }
        } else {
          this.$router.push('/')
        }
      })
    },
    methods: {
    },
  }
</script>
<style>

</style>